export default "__VITE_PUBLIC_ASSET__571b4bc5__"